import React from 'react';
import { ArrowRight, X, CheckCircle, Info } from '@phosphor-icons/react';
const inhouse = [{
  label: 'Salary',
  value: '$65,000 to $85,000'
}, {
  label: 'Superannuation (11.5%)',
  value: '$7,475 to $9,775'
}, {
  label: 'Software seats (Xero, Dext)',
  value: '$1,800 to $3,000'
}, {
  label: 'Recruitment and onboarding',
  value: '$5,000 to $12,000'
}, {
  label: 'Supervision and quality control',
  value: 'Your time'
}, {
  label: 'Leave cover and continuity',
  value: 'Disruption risk'
}];
const knight = [{
  label: 'Fixed monthly fee',
  value: 'Scoped to your needs'
}, {
  label: 'Supervision (IPA-recognised)',
  value: 'Included'
}, {
  label: 'Software setup and access',
  value: 'Included'
}, {
  label: 'Onboarding',
  value: 'No startup cost'
}, {
  label: 'Quality control and SLA',
  value: 'Included'
}, {
  label: 'Leave and continuity cover',
  value: 'Built into the team'
}];
export function CostComparison() {
  return <section className="py-16 lg:py-24 bg-near-black relative overflow-hidden" data-id="element-15">
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-16"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-17">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-18">
          <p className="font-mono text-[11px] tracking-wider uppercase text-knight-orange mb-3" data-id="element-19">
            The maths most providers will not show you
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-5" data-id="element-20">
            In-house bookkeeper vs Knight
          </h2>
          <p className="text-lg text-gray-400 leading-relaxed" data-id="element-21">
            Knight is not the cheapest option. We are the option that costs less
            than hiring, with more capability than hiring. Here is how the real
            numbers compare.
          </p>
        </div>

        <div className="max-w-5xl mx-auto rounded-md border border-hairline-dark overflow-hidden" data-id="element-22">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-23">
            <div className="p-7 lg:p-9 bg-[#161616] border-b md:border-b-0 md:border-r border-hairline-dark" data-id="element-24">
              <div className="flex items-center gap-2 mb-6" data-id="element-25">
                <div className="w-7 h-7 rounded-full bg-white/5 flex items-center justify-center" data-id="element-26">
                  <X size={14} weight="bold" className="text-gray-500" data-id="element-27" />
                </div>
                <div className="font-mono text-[10px] uppercase tracking-wider text-gray-500" data-id="element-28">
                  Hire in-house
                </div>
              </div>
              <ul className="space-y-3.5" data-id="element-29">
                {inhouse.map((row, i) => <li key={i} className="flex justify-between items-baseline gap-4 border-b border-hairline-dark pb-3 last:border-0 last:pb-0" data-id="element-30">
                    <span className="text-sm text-gray-300" data-id="element-31">{row.label}</span>
                    <span className="font-mono text-xs text-white text-right" data-id="element-32">
                      {row.value}
                    </span>
                  </li>)}
              </ul>
              <div className="mt-6 pt-6 border-t border-hairline-dark" data-id="element-33">
                <div className="font-mono text-[10px] uppercase tracking-wider text-gray-500 mb-1" data-id="element-34">
                  Typical fully loaded cost
                </div>
                <div className="font-mono text-2xl font-semibold text-white" data-id="element-35">
                  $80,000+{' '}
                  <span className="text-sm text-gray-500" data-id="element-36">per year</span>
                </div>
              </div>
            </div>

            <div className="p-7 lg:p-9 bg-[#1d1d1d]" data-id="element-37">
              <div className="flex items-center gap-2 mb-6" data-id="element-38">
                <div className="w-7 h-7 rounded-full bg-knight-orange/15 flex items-center justify-center" data-id="element-39">
                  <CheckCircle size={14} weight="fill" className="text-knight-orange" data-id="element-40" />
                </div>
                <div className="font-mono text-[10px] uppercase tracking-wider text-knight-orange" data-id="element-41">
                  Hire Knight
                </div>
              </div>
              <ul className="space-y-3.5" data-id="element-42">
                {knight.map((row, i) => <li key={i} className="flex justify-between items-baseline gap-4 border-b border-hairline-dark pb-3 last:border-0 last:pb-0" data-id="element-43">
                    <span className="text-sm text-gray-300" data-id="element-44">{row.label}</span>
                    <span className="font-mono text-xs text-knight-orange text-right" data-id="element-45">
                      {row.value}
                    </span>
                  </li>)}
              </ul>
              <div className="mt-6 pt-6 border-t border-hairline-dark" data-id="element-46">
                <div className="font-mono text-[10px] uppercase tracking-wider text-knight-orange mb-1" data-id="element-47">
                  Fixed monthly fee
                </div>
                <div className="font-mono text-2xl font-semibold text-white" data-id="element-48">
                  Scoped{' '}
                  <span className="text-sm text-gray-500" data-id="element-49">
                    to your business
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mt-8 flex items-start gap-3 text-xs text-gray-500 font-mono leading-relaxed" data-id="element-50">
          <Info size={14} weight="regular" className="text-gray-500 flex-shrink-0 mt-0.5" data-id="element-51" />
          <p data-id="element-52">
            Typical Australian fully-loaded cost ranges based on publicly
            available salary data, software list pricing and standard
            recruitment fees. Your actual numbers will vary by location, role
            scope and benefits package. Final Knight pricing is quoted after a
            free consultation.
          </p>
        </div>

        <div className="text-center mt-12" data-id="element-53">
          <a href="#lead" className="inline-flex items-center px-8 py-4 bg-knight-orange text-white font-semibold rounded-md hover:bg-knight-orange-hover transition-colors duration-300 ease-out-expo" data-id="element-54">
            Get my fixed-fee quote
            <ArrowRight size={18} weight="regular" className="ml-2" data-id="element-55" />
          </a>
          <p className="font-mono text-[11px] tracking-wide text-gray-500 uppercase mt-4" data-id="element-56">
            No startup costs / No lock-in / Free consultation
          </p>
        </div>
      </div>
    </section>;
}